// Data-completeness scoring for a School Unit in the Admin hierarchy tree.
// Green  → NPSN + biaya utama (SPP) + deskripsi + kurikulum semua terisi
// Yellow → NPSN & biaya utama terisi TAPI deskripsi/kurikulum masih kosong
// Red    → NPSN belum diisi ATAU biaya utama (SPP) belum diisi

export const CompletenessLevel = { GREEN: "green", YELLOW: "yellow", RED: "red" };

/**
 * @param u   partial School document (must expose: npsn, spp_min, spp_max, description, curriculum)
 * @returns { level, missing: string[] }
 */
export function completenessOf(u) {
  const missing = [];
  const hasNpsn = !!(u?.npsn && String(u.npsn).trim());
  const hasBiaya = Number(u?.spp_min) > 0 || Number(u?.spp_max) > 0;
  const hasDesc = !!(u?.description && String(u.description).trim().length >= 30);
  const hasCurric = Array.isArray(u?.curriculum) && u.curriculum.length > 0;

  if (!hasNpsn) missing.push("NPSN");
  if (!hasBiaya) missing.push("SPP");
  if (!hasDesc) missing.push("Deskripsi");
  if (!hasCurric) missing.push("Kurikulum");

  if (!hasNpsn || !hasBiaya) return { level: CompletenessLevel.RED, missing };
  if (!hasDesc || !hasCurric) return { level: CompletenessLevel.YELLOW, missing };
  return { level: CompletenessLevel.GREEN, missing };
}

export const COMPLETENESS_META = {
  green:  { color: "#16A34A", bg: "#DCFCE7", label: "Lengkap" },
  yellow: { color: "#CA8A04", bg: "#FEF9C3", label: "Parsial" },
  red:    { color: "#DC2626", bg: "#FEE2E2", label: "Kritis"  },
};
